import { render, staticRenderFns } from "./FootNav.vue?vue&type=template&id=e4004eac&scoped=true&"
import script from "./FootNav.vue?vue&type=script&lang=js&"
export * from "./FootNav.vue?vue&type=script&lang=js&"
import style0 from "./FootNav.vue?vue&type=style&index=0&id=e4004eac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4004eac",
  null
  
)

export default component.exports